import React from "react";
import PropTypes from "prop-types";

const AssignedTo = ({ users, isOnlyData }) => {
  const len = users ? users.length : 0;
  if (len === 0) {
    return "-";
  }

  const data = users.map((user, index) => (
    <span key={user.id}>
      <a href={"/users/" + user.id} className="styled-link pointer-hand">
        {user.full_name_reverse}
      </a>

      <br />
    </span>
  ));

  if (isOnlyData) {
    return data;
  }

  return (
    <tr>
      <th>Assigned To</th>
      <td>{data}</td>
    </tr>
  );
};

AssignedTo.propTypes = {
  users: PropTypes.array,
  isOnlyData: PropTypes.bool
};

AssignedTo.defaultProps = {
  isOnlyData: false
};

export default AssignedTo;
